
import CreatePeOrderForm from 'presentation/containers/modules/pe/forms/CreatePeOrderForm';
import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import { FC } from 'react';

const CreatePeOrderPage: FC = () => {
  return (
    <ActivesPageLayout>
      <CreatePeOrderForm/>
    </ActivesPageLayout>
  );
};

export default CreatePeOrderPage;
